export { default as withCalculator } from './withCalculator';
export { default as withRouter } from './withRouter';
export { default as withClient, withClientProvider } from './withClient';
export { CookiesProvider } from 'react-cookie';



// WEBPACK FOOTER //
// ../pos-master/packages/pos-hoc/src/index.js